import waveApi from '../wave/waveApi';
import mondayInvoiceService from '../monday/mondayInvoiceService';

class InvoiceSyncService {
  // Create invoice in Wave from Monday.com data
  async createWaveInvoice(mondayItemId) {
    try {
      // Get invoice details from Monday.com
      const mondayInvoice = await mondayInvoiceService.getInvoiceDetails(mondayItemId);
      
      // Transform Monday.com data to Wave format
      const waveInvoiceData = this.transformToWaveFormat(mondayInvoice);
      
      // Create invoice in Wave
      const waveResponse = await waveApi.createInvoice(waveInvoiceData);
      const waveInvoiceId = waveResponse.data.invoiceCreate.invoice.id;
      
      // Update Monday.com with Wave invoice ID and status
      await mondayInvoiceService.updateInvoiceStatus(
        mondayItemId,
        'Sent',
        waveInvoiceId
      );

      return waveInvoiceId;
    } catch (error) {
      console.error('Error creating Wave invoice:', error);
      throw error;
    }
  }

  // Sync invoice status from Wave to Monday.com
  async syncInvoiceStatus(mondayItemId, waveInvoiceId) {
    try {
      const waveInvoice = await waveApi.getInvoiceById(waveInvoiceId);
      const status = this.mapWaveStatusToMonday(waveInvoice.status);
      
      await mondayInvoiceService.updateInvoiceStatus(
        mondayItemId,
        status,
        waveInvoiceId
      );
    } catch (error) {
      console.error('Error syncing invoice status:', error);
      throw error;
    }
  }

  // Helper method to transform Monday.com data to Wave format
  transformToWaveFormat(mondayInvoice) {
    // Extract values from Monday.com column_values
    const columns = mondayInvoice.items[0].column_values;
    
    return {
      customerId: columns.find(c => c.id === 'customer')?.value,
      currency: 'USD',
      dueDate: columns.find(c => c.id === 'date4')?.text,
      items: [
        {
          productId: columns.find(c => c.id === 'product')?.value,
          quantity: parseInt(columns.find(c => c.id === 'quantity')?.text || '1'),
          unitPrice: parseFloat(columns.find(c => c.id === 'price')?.text || '0')
        }
      ]
    };
  }

  // Helper method to map Wave status to Monday.com status
  mapWaveStatusToMonday(waveStatus) {
    const statusMap = {
      DRAFT: 'Draft',
      SENT: 'Sent',
      VIEWED: 'Viewed',
      PAID: 'Paid',
      OVERDUE: 'Overdue',
      CANCELLED: 'Cancelled'
    };
    return statusMap[waveStatus] || waveStatus;
  }
}

export default new InvoiceSyncService(); 